<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="6">
                <ValidatableTextField v-model:form="form" label="3-letter Code" :field="'_3_letter_code'" />
            </v-col>
            <v-col cols="12" sm="6">
                <ValidatableTextField v-model:form="form" label="Name" :field="'name'" />
            </v-col>
            <v-col cols="12">
                <Autocomplete v-model:selected-items="form.country_id" v-model:form="form" :items="countries" :field-name="'country_id'" :loading="fetchingCountries" label="Country" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { type IState } from '@app/location/state/models/State';
import { useStateRepository } from '@app/location/state/repositories/useStateRepository';
import { useCountryRepository } from '@app/location/country/repositories/useCountryRepository.ts';

const props = defineProps({
    item: {
        type: Object as PropType<IState>,
        required: true,
    },
});

const update = useStateRepository().command.update(props.item.id, props.item);
const form = update.form;
useInjectSubmitForm(update.execute);

const { countries, fetchingCountries } = useCountryRepository().query.list();
</script>
